import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getAllLedgers = createAsyncThunk(
    'ledger/getAllLedgers',
    async ({ skip, limit, search, status, customer_id, agent_id }, { rejectWithValue }) => {
        try {
            const params = {};
            if (skip !== undefined) params.skip = skip;
            if (limit !== undefined) params.limit = limit;
            if (search) params.search = search;
            if (status) params.status = status;
            if (customer_id) params.customer_id = customer_id;
            if(agent_id) params.customer_id = customer_id;

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                params,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/ledgers`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    response: {
                        data: {
                            message: "Network Error",
                            status: err.code,
                            statusText: err.code,
                        },
                    },
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const getLedgerById = createAsyncThunk(
    'ledger/getLedgerById',
    async ({ id }, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/orders/customer/ledger/${id}`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    response: {
                        data: {
                            message: "Network Error",
                            status: err.code,
                            statusText: err.code,
                        },
                    },
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const addNewLedger = createAsyncThunk(
    'ledger/addNewLedger',
    async (ledgerData, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const body = JSON.stringify(ledgerData);

            const response = await axios.post(`${PUBLIC_BASE_URL}/ledgers/create-ledger`, body, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);

export const editLedger = createAsyncThunk(
    'ledger/editLedger',
    async (updatedData, { rejectWithValue }) => {
        try {

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const body = JSON.stringify(updatedData);
            const response = await axios.put(`${PUBLIC_BASE_URL}/ledgers/update-ledger-info`, body, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);
